// extracted by mini-css-extract-plugin
module.exports = {"Archive":"Magazine_Archive_Archive__kj8tW"};